









































import { Vue, Component } from 'vue-property-decorator'
import Button from '../Button/index.vue'
import IconInfo from '../../assets/ics_f_icon_circle.vue'
import IconCheck from '../../assets/ics_f_check_circle.vue'
import Loading from '../Loading/index.vue'
import AuthController from '../../controllers/AuthController'

interface MfaStatus {
  badgeClass: string;
  iconComponent: string;
  iconColor: string;
  text: string;
  dataTestid: string;
}

@Component({
  components: {
    Button,
    IconInfo,
    IconCheck,
    Loading
  }
})
class MfaProfileDropdownBlock extends Vue {
  get isLogin2faEnabled(): boolean {
    return AuthController.isLogin2faEnabled
  }

  get isLogin2faEnrolled(): boolean {
    return AuthController.isLogin2faEnrolled
  }

  get mfaStatus(): MfaStatus {
    if (this.isLogin2faEnrolled) {
      return {
        badgeClass: 'bg-green-200 text-green-3',
        iconComponent: 'IconCheck',
        iconColor: '#00875A',
        text: 'Aktif',
        dataTestid: 'navbar-mfa-badge-active'
      }
    }
    return {
      badgeClass: 'bg-orange-1 text-orange-600',
      iconComponent: 'IconInfo',
      iconColor: '#CD4425',
      text: 'Belum diaktifkan',
      dataTestid: 'navbar-mfa-badge-inactive'
    }
  }

  get mfaDescription(): string {
    if (this.isLogin2faEnrolled) {
      return 'Verifikasi kode OTP akan dikirim via <b>email</b>. Kode OTP akan diminta setiap kali login.'
    }
    return 'Berikan keamanan tambahan dengan mengaktifkan verifikasi kode OTP via <b>email</b>. Kode OTP akan diminta setiap kali login.'
  }

  get isLoadingProcess(): boolean {
    return AuthController.isLoading
  }

  onActive(): void {
    AuthController.navigateToMfaEnrollment()
  }
}

export default MfaProfileDropdownBlock
